// Module
var code = `<div class="js-link-label {{.subclass}}" style="{{>visibility}}" {{^.enabled}}disabled="" {{/}} on-click="linkClick">
    <a {{#.linkHref}}href="{{.linkHref}}" {{/}} target="_blank" rel="noopener noreferrer" as-tooltip="tooltip">{{.text}}</a>
</div>`;
// Exports
export default code;